import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StyledBox = styled(Box)({
  padding: '0 5% 100px 5%'
});



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPageContainer/styles.js